module.exports = "<cms-header *ngIf=\"loggedIn\"></cms-header>\n\n<main class=\"main\">\n  <div class=\"container\">\n    <cms-menu *ngIf=\"loggedIn\"></cms-menu>\n\n    <section class=\"page\">\n      <router-outlet></router-outlet>\n    </section>\n  </div>\n</main>\n\n<cms-alert></cms-alert>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main